import { render } from "./QuickMediaInput.vue?vue&type=template&id=6a94dc44"
import script from "./QuickMediaInput.vue?vue&type=script&lang=js"
export * from "./QuickMediaInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__